import React, { useEffect } from "react";
import Helmet from "react-helmet";
import styled from "@emotion/styled";
import { Link } from "gatsby";
import { Box } from "@src/components/Boxes";
import { mediaQueriesMax } from "@src/styles/theme";
import LessonCover from "@src/components/ideas/LessonCover";
import LessonRecommendations from "@src/components/ideas/LessonRecommendations";
import LessonPublisher from "@src/components/ideas/LessonPublisher";
import { logEvent } from "@src/utils/logClient";

const tags = ["CCSS.ELA-LITERACY.SL.4.1", "Growth Mindset"];

const LessonBack = styled("div")`
  font-size: 16px;
  font-weight: 500;
  color: #00aeef;
  line-height: 1;

  &:hover {
    cursor: pointer;
    color: #00baff;
  }
`;

const LessonContainer = styled("div")`
  max-width: 704.5px;
  padding: 49.8px 0 20px 0;
  margin: 0 auto;

  ${mediaQueriesMax.lesson} {
    padding: 20px 16px 20px 16px;
  }
`;

const Lesson = ({ pageContext }) => {
  const lesson = pageContext.lesson;
  const board = pageContext.board;

  const backLinkEnabled = false;

  const meta = {
    title: lesson.title,
    teaser: lesson.description,
  };

  let backLink = null;

  if (board) {
    backLink = (
      <LessonBack>
        <Link to={board.slug}>&larr; {board.title}</Link>
      </LessonBack>
    );
  }

  useEffect(() => {
    logEvent({
      eventName: "ideas.activityView",
      eventValue: lesson.slug,
    });
  }, []);

  return (
    <div>
      <Helmet>
        <title>{meta.title} - Big Ideas - Classdojo</title>
        <script src="https://static.classdojo.com/radiant-media-player/js/rmp.min.js" key="rmp" />
      </Helmet>
      <Box backgroundColor="white">
        <LessonContainer>
          {backLinkEnabled && backLink}

          <LessonCover
            lesson={lesson}
            meta={meta}
            tags={tags}
            description={lesson.description}
            discussionGuideLink={lesson.discussion_guide_link}
            showButton={lesson.show_button == null ? true : lesson.show_button}
          />
          <LessonPublisher visible={lesson.show_publisher} publisher={lesson.publisher} lesson={lesson} />
          <LessonRecommendations ideas={lesson.related} />
        </LessonContainer>
      </Box>
    </div>
  );
};

export default Lesson;
